import React from "react";
import { InjectedAccountWithMeta } from "@polkadot/extension-inject/types";
import { AddressAvatar } from "./AddressAvatar";
import Confetti from "react-confetti";

interface SuccessProps {
  substrateAccount: InjectedAccountWithMeta;
  ethAddress: string;
}

const Success: React.FC<SuccessProps> = ({ substrateAccount, ethAddress }) => {
  return (
    <div className="fixed top-0 left-0 flex justify-center items-center w-screen h-screen bg-black bg-opacity-50">
      <Confetti
        width={window.outerWidth}
        height={window.outerHeight}
        recycle={false}
        tweenDuration={10_000}
        numberOfPieces={600}
      />
      <div className="flex flex-col justify-center items-center gap-6 h-64 w-[448px] bg-white border border-acala-blue-400 rounded-xl z-10">
        <h1 className="text-2xl text-gray-900 font-semibold">
          Accounts Bound!
        </h1>
        <div className="flex flex-row justify-start items-center gap-2 w-64 h-12 px-3 border border-acala-blue-400 rounded-md">
          <AddressAvatar theme="polkadot" address={substrateAccount.address} />
          <div className="text-lg font-medium">
            {substrateAccount.meta.name}
          </div>
        </div>
        <div className="flex flex-row justify-start items-center gap-2 w-64 h-12 px-3 border border-acala-blue-400 rounded-md">
          <AddressAvatar theme="beachball" address={ethAddress} />
          <div className="text-lg font-medium">
            {`${ethAddress.slice(0, 6)}...${ethAddress.slice(
              ethAddress.length - 6
            )}`}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Success;
